
import { useContext, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Box, Grid, Stack, Typography } from "@mui/material";
import "./workgroupcard.scss";
import CircleIcon from '@mui/icons-material/Circle';
import WorkGroupAction from "../../../Components/WorkGroup/WorkGroupAction";
import WorkGroupView from "../../../Components/WorkGroup/WorkGroupView";
import { useGetWorkGroupById } from "../../../Hooks/useGetWorkGroupById";


export default function WorkGroupCard({ item, setRefetch }) {
    const { t } = useContext(AuthContext);

    const [openView, setOpenView] = useState(false)
    const handleOpenView = () => setOpenView(true)
    const handleCloseView = () => setOpenView(false)

    const { workGroupData, refetchWorkGroupById } = useGetWorkGroupById({ id: item?._id })

    return (
        <Box className="work-group-card">
            <Grid container direction="row" >
                <Grid item xs={10.5}>
                    <Stack direction="row" alignItems="center" spacing={4} onClick={handleOpenView} >
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                            <Typography className="numbers-ballot">{t("thead_work_group_number")}</Typography>
                            <Typography className="numbers">{item?.numbering}</Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={2.4}>
                            <Stack direction={"column"} spacing={1.5}>
                                <Typography  className="work-group-title">
                                    {item?.work_group_name}
                                </Typography>
                                <Stack direction="column" spacing={0.5}>
                                    <Stack direction="row" alignItems="center" spacing={0.8}>
                                        <CircleIcon sx={{ fontSize: 6, color: "#37353E !important" }} />
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <Typography className="numbers-ballot" color="gray !important">{t("thead_total_member_work_group")}</Typography>
                                            <Typography className="numbers-ballot" color="gray !important">{item?.summary_info?.total_group_member}{t("thead_people")} {t("thead_female")} {item?.summary_info?.total_group_member_as_female}{t("thead_people")}</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction="row" alignItems="center" spacing={0.8}>
                                        <CircleIcon sx={{ fontSize: 6, color: "#37353E !important" }} />
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <Typography className="numbers-ballot" color="green !important">{t("thead_total_council_member_work_group")}</Typography>
                                            <Typography className="numbers-ballot" color="green !important">{item?.summary_info?.total_council_member}{t("thead_people")} {t("thead_female")} {item?.summary_info?.total_council_member_as_female}{t("thead_people")}</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction="row" alignItems="center" spacing={0.8}>
                                        <CircleIcon sx={{ fontSize: 6, color: "#37353E !important" }} />
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <Typography className="numbers-ballot" color="green !important">{t("thead_total_secretary_member_work_group")}</Typography>
                                            <Typography className="numbers-ballot" color="green !important">{item?.summary_info?.total_secretary_member}{t("thead_people")} {t("thead_female")} {item?.summary_info?.total_secretary_member_as_female}{t("thead_people")}</Typography>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Stack>

                        </Stack>
                    </Stack>
                </Grid>

                <Grid item xs={1.5}>
                    <WorkGroupAction
                        item={item}
                        setRefetch={setRefetch}
                    />
                </Grid>
            </Grid>
            <WorkGroupView
                open={openView}
                setOpenView={setOpenView}
                workGroupData={workGroupData}
                handleClose={handleCloseView}
                dialogTitle={"View"}
            />
        </Box>
    );

}